// URL helpers for the Operations catalog (both modes).

export type OpsMode = 'ours' | 'atlassian'

export const modeOf = (p: URLSearchParams): OpsMode => (p.get('mode') === 'atlassian' ? 'atlassian' : 'ours')

/** `?domain=fields,users` → ['fields', 'users'] */
export const listParam = (p: URLSearchParams, key: string) =>
  (p.get(key) ?? '').split(',').map((s) => s.trim()).filter(Boolean)

export const count = <K,>(m: Map<K, number>, k: K) => m.set(k, (m.get(k) ?? 0) + 1)
